import React from 'react';

import {OnboardingGuard} from './OnboardingGate';
import {OnboardingLayout} from './OnboardingLayout';

/**
 * Una pantalla del túnel: el guardián, el marco y el paso.
 *
 * Existe para que la tabla de rutas se lea de un vistazo — sin esto, cada paso repite tres
 * componentes anidados y la ruta deja de decir cuál es su pantalla.
 */
export function OnboardingScreen({step, children}) {
    return (
        <OnboardingGuard>
            <OnboardingLayout step={step}>{children}</OnboardingLayout>
        </OnboardingGuard>
    );
}
